import * as React from 'react';
import {default as SendIcon} from '@material-ui/icons/Send';
import {connect} from 'react-redux';
import * as FileActions from '@services/file/file.actions';
import {IFamilyMember} from '@app-types/websocket/family.types';
import {withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {imageFlowStyle} from './imageflow.style';
import {ICreateFlowPost} from '@app-types/websocket/imageflow.types';
import {default as AddImageIcon} from '@material-ui/icons/AddPhotoAlternateOutlined';
import {default as RotateIcon} from '@material-ui/icons/RotateRightRounded';
import {default as ZoomInIcon} from '@material-ui/icons/ZoomInRounded';
import {default as ZoomOutIcon} from '@material-ui/icons/ZoomOutRounded';
import * as ImageFlowActions from '@services/imageflow/imageflow.actions';
import Button from '@components/common/button/Button';
import { IStuffBeingUploaded, IFinishedUpload,IUploadFile} from '@app-types/websocket/file.types';
import Dialog from "@components/common/dialog/dialog.component";
import Input from "@components/common/input/input.component";
import AvatarEditor from 'react-avatar-editor';
import {displayErrorMessage} from '@services/user/user.actions';
import { styleColors } from 'src/main.style';
import { handleBlobUpload, fileToBase64 } from '@helpers/uploadHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof imageFlowStyle> {
  family: IFamilyMember[];
  user: IFamilyMember | undefined;
  open: boolean;

  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];

  uploadFile: (file: IUploadFile) => void;
  uploadedFileUsed: (file: number) => void;
  displayErrorMessage: (msg: string) => void;

  close: () => void;
  create: (data: ICreateFlowPost) => void;
}

interface IState {
  msg: string;

  internalUploadId: number|null;
  dataUrl: string;
  mime:string;
  rotation: number;
  scale: number;
  saveClicked:boolean;
}

class ImageFlowPostNew extends React.Component<IProps, IState> {

  private inputRef: React.RefObject<HTMLInputElement>;
  private editorRef: React.RefObject<AvatarEditor>;

  constructor(props: IProps) {
    super(props);
    this.editorRef = React.createRef();
    this.inputRef = React.createRef<HTMLInputElement>();
    this.state = {
      msg: "",
      saveClicked:false,
      dataUrl: '',
      mime:"",
      rotation: 0,
      scale: 1,
      internalUploadId:null,
    };
  }

  public componentDidUpdate(oldProps:IProps) {
    if (this.props.open === false && oldProps.open === true) {
      this.setState({
        msg: "",
        saveClicked:false,
        dataUrl: '',
        mime:"",
        internalUploadId:null,
        rotation: 0,
        scale:1,
      })
    } else if (this.props.open === true && oldProps.open === false) {
      setTimeout(() => {if (this.inputRef.current) {this.inputRef.current.focus();}}, 400);
    }

    for (const file of this.props.uploadedFiles) {
      if (file.internalId === this.state.internalUploadId && this.state.saveClicked ) {
        this.props.uploadedFileUsed(file.id);
        if (file.id) {
          this.props.create({msg: this.state.msg, attachmentId: file.id});
          this.props.close();
        }
      }
    }
  }

  public render() {

    const {classes} = this.props;
    let disableSend = true;

    let attachmentId: number | undefined ;

    const uploadedFile: IFinishedUpload | undefined = this.props.uploadedFiles.find((f) => f.internalId === this.state.internalUploadId);
    const uploadingFile: IStuffBeingUploaded | undefined = this.props.uploadingFiles.find((f) => f.internalId === this.state.internalUploadId);

    let uploadContent = <div/>;

    if (this.state.dataUrl !== '') {

      disableSend = false;
      if (this.state.saveClicked) {
        disableSend = true;
      }
      if (this.state.mime.includes("image")) {
        uploadContent = <div style={{position:'relative'}}>
          <div className={this.state.saveClicked?classes.disableEdit:classes.enableEdit}>
            {tn.lang.uploading+(uploadingFile?(" "+uploadingFile.loaded):"...")}
          </div>
          <AvatarEditor
            ref={this.editorRef}
            image={this.state.dataUrl}
            style={{ width: "100%", height: "100%", maxWidth: "400px", maxHeight: "400px" }}
            border={0}
            width={600}
            height={600}
            borderRadius={0}
            rotate={this.state.rotation}
            color={[255, 255, 255, 1]}
            scale={this.state.scale}
          />
          <div className={classes.fabRotate} onClick={() => this.handleRotate()}>
            <RotateIcon style={{opacity:0.8}}/>
          </div>
          <div className={classes.fabRotate} style={{left:52}} onClick={() => this.handleZoom(false)}>
            <ZoomOutIcon style={{opacity:0.8}}/>
          </div>
          <div className={classes.fabRotate} style={{left:98}}  onClick={() => this.handleZoom(true)}>
            <ZoomInIcon style={{opacity:0.8}}/>
          </div>
        </div>
      } else if (this.state.mime.includes("video")) {
        uploadContent = <div className={this.props.classes.img} style={{backgroundImage: "url(\"" + this.state.dataUrl + "\")"}} />;
      } else {
        uploadContent = <div className={this.props.classes.img} style={{backgroundImage: "url(\"" + this.state.dataUrl + "\")"}}>
          unknown
        </div>;
      }

    } else if (!uploadedFile && !uploadingFile) {
      uploadContent = <label htmlFor="add-file-direct"
        onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}}
        style={{display: 'flex', alignItems: 'center', backgroundColor: styleColors.greyLight3, padding: '30px', borderRadius: '100px',
        color: styleColors.greyDark1, fontSize: '16px', fontWeight: 500, position: 'relative'}}>

        <input type="file" accept="capture=camera,image/*" ref={this.inputRef} multiple={false} 
          style = {{opacity:0, position: 'absolute', width:'80%'}} id={"add-file-direct"}
          onChange={this.updateLocalImage} />

        <AddImageIcon style={{color: styleColors.greyDark2, width: '50px', height: '50px'}}
          onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}}/>
      </label>
    } else {
      let progress = <div/>;
      if (uploadedFile) {
        disableSend = false;
        attachmentId = uploadedFile.id;
      } else if (uploadingFile) {
        if (uploadingFile.loaded === 100 && uploadingFile.id) {
          disableSend = false;
          attachmentId = uploadingFile.id;
        }
        progress = <div className={this.props.classes.percentageText}>{uploadingFile.loaded}%</div>;
      }
      uploadContent = <div className={this.props.classes.img}
                           style={{backgroundImage: "url(\"" + this.state.dataUrl + "\")"}}>
        {progress}
      </div>;
    }

    return (
      <Dialog
        fullWidth={true}
        open={this.props.open}
        onClose={() => this.abort()}
        title={tn.lang.flowPostNew}
        content={
          <div className={this.props.classes.newPostDialogContent}>
            <div className={this.props.classes.newPostContent}>
              {uploadContent}
            </div>
            <Input
              id="new-fp-comment"
              type="text"
              value={this.state.msg}
              onChange={(event) => this.setState({msg: event.target.value})}
              className={this.props.classes.editComment}
              autoCorrect="on"
              spellCheck={true}
              autoComplete="off"
              maxLength={1024}
              disabled={this.state.saveClicked}
              placeholder={tn.lang.flowPostSddComment}/>
          </div>
        }
        actions={
          <>
            <Button size="small" variant="contained" color="default" onClick={() => this.abort()}>
              {tn.lang.cancel}</Button>
            <Button size="small" variant="contained" color="primary" disabled={disableSend}
              onClick={() => {
                if (this.editorRef.current) {
                  this.setState({saveClicked:true});

                  try {
                    const canvas = document.createElement('canvas');
                      canvas.width = 1600;
                      canvas.height = 1600;

                    const context = canvas.getContext('2d');
                    const areaLimit = (this.editorRef.current.getImage().width > 4095 || this.editorRef.current.getImage().height > 4095);

                    if (context !== null) {
                      context.drawImage(areaLimit 
                        ? this.editorRef.current.getImageScaledToCanvas() 
                        : this.editorRef.current.getImage(), 0, 0, 1600, 1600);
                    }

                    canvas.toBlob((blob) => {
                      if(blob && this.editorRef.current){
                        const d = handleBlobUpload(blob, "flow.png", this.props.uploadFile);
                        this.setState({internalUploadId: d.internalId})
                      }
                    })
                  } catch (e) {
                    this.props.displayErrorMessage("Image upload failed");
                    this.setState({saveClicked:false, internalUploadId:null});
                    return;
                  }
                }
              }}>
              <span style={{flex: 1}}>{tn.lang.send}</span>
              <SendIcon fontSize="inherit"/>
            </Button>
          </>
        }
      />
    );
  }

  private handleRotate = () => {
    this.setState(prev => ({ rotation: (prev.rotation + 90) % 360 }));
  };

  private handleZoom = (zoomIn:boolean) => {
    this.setState(prev => ({ scale: Math.min(Math.max((prev.scale + (zoomIn?0.25:-0.25)),1),10) }));
  };

  private abort = () => {
    const uploadedFile: IFinishedUpload | undefined = this.props.uploadedFiles.find((f) => f.internalId === this.state.internalUploadId);
    const uploadingFile: IStuffBeingUploaded | undefined = this.props.uploadingFiles.find((f) => f.internalId === this.state.internalUploadId);

    if (uploadedFile) {
      this.props.uploadedFileUsed(uploadedFile.id);
    } else if (uploadingFile) {
      this.props.uploadedFileUsed(uploadingFile.id);
    }
    this.setState({internalUploadId:null, msg: "", saveClicked:false});

    this.props.close();
  };

  private updateLocalImage = async (event: any) => {
    try {
      const { files } = event.target;
      if (files && files.length > 0 || (event.files && event.files.length > 0)) {
        const f:File = files.item(0) ? files.item(0) : event.files.item(0);
        if (f.type && f.type.toLowerCase().includes("image")) {
          const data = await fileToBase64(f);
          this.setState({dataUrl:  'data:'+f.type+';base64,'  + data, mime:f.type});
        } else if (f.type && f.type.toLowerCase().includes("video")) {
          this.props.displayErrorMessage("Videos not supported yet");
        }
      }
    } catch (error) {
      console.error("Failed to read selected flow image", error);
      this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
    }
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const family: IFamilyMember[] = state.family.family;
  const user: IFamilyMember | undefined = family.find((mem: IFamilyMember) => mem.id === userId);

  return {
    family,
    user,
    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
  };
}

const mapDispatchToProps = {
  create: ImageFlowActions.imageFlowCreate,
  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  displayErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(imageFlowStyle)(ImageFlowPostNew));



// WEBPACK FOOTER //
// ./src/components/imageflow/ImageFlowPostNew.tsx